<template>
  <div class="first-level">
    <table class="table-a">
      <tr>
        <!--<th>{{ravHtml}}</th>-->
        <th v-bind:class="color">{{message}}</th>
        <th v-if="see">you can see this line</th>
        <th v-if="see" v-bind:class="param[0].value">{{param[0].name}}:you can see this line</th>
        <th><p class="b">{{number + 1}}</p></th>
        <p class="b">{{isOk ? param[0] : param[1].name}}</p>
        <p class="c">{{!isOk ? param[0] : param[1].name}}</p>
        <p class="d">{{!isOk ? param[0] : param[1].value}}</p>
        <p class="e">{{message.split(".").reverse().join("-")}}</p>
      </tr>
      <tr>
        <td v-if="list[0] === number">v-if is {{number}}}</td>
        <td v-else-if="list[1] === number -1"> v-else-if {{number }}</td>
        <td v-else>v-else {{number}}</td>
        <td v-if="isOk">v-if 是真正的条件渲染 在切换的过程中条件块内的事件监听和子组件适当地被销毁和重建·</td>
        <td v-show="isOk">v-show 是初始就渲染好了，只是简单的进行css切换</td>
      </tr>
    </table>
    <div class="second-level-div-a">
      <p v-html="ravHtml"></p>
      <span v-html="ravHtml"></span>
    </div>
    <div class="second-level-div-b">
      <p v-if="isOk">this is the div</p>
    </div>
    <div class="second-level-div-c" @click="click_a(isOk)">
      <div class="third-level-div-a" @click="click_b">
        you can point this click
      </div>
      <div class="third-level-div-b" @click.stop="click_c(isOk)">
        you can point this click which is only effect this div
      </div>
      <div class="third-level-div-c"
           v-bind:class="{font_change:isOk, green:isOk}"
           @click.stop="click_c(isOk)">
        class bind style
      </div>
      <div class="third-level-div-d"
           v-bind:class="[isOk ? 'font_change': '', isOk ? 'green':'']"
           @click.stop="click_c(isOk)">
        class bind style
      </div>
      <div class="third-level-div-e"
           v-bind:style="{color: isOk? param[0].value : param[1].value, fontSize: isOk ? 'font_change': '', background : isOk ? 'green':''}"
           @click.stop="click_c(isOk)">
        内联样式改变
      </div>
    </div>
    <div class="second-level-div-d" @click="click_a(isOk)">
      <!--v-for 测试-->
      <ul>
        <li v-for="item,index in param">
          {{item.name}}:{{item.value}}---index:{{index}}
          <p v-for="value,key in item">字段名：{{key}}，字段值：{{value}}</p>
        </li>
      </ul>
      <ul>
        <li v-for="item,index in list">
          {{item}}---index:{{index}}
        </li>
      </ul>
    </div>
    <div class="second-level-div-e">
      <button
        v-bind:class="{color: isOk? param[2].value : '', background: isOk? color:''}"
        v-on:click="number += 1">点击数值变化：{{number}}
      </button>
      <button
        v-bind:class="isOk? buttonControl[1] : buttonControl[2]"
        v-on:click="click_event(number, 'click_event(x,y,e)', $event)">{{message}}, number：{{number}}
      </button>
     <!-- <button
        v-bind:style="{}"
        v-on:mouseleave="buttonControl[3]()">
        离开按钮
      </button>-->
      <!--<button
        v-on:mouseover="{color:buttonParam.changeColor, background:buttonParam.changeBackground, fontSize: buttonParam.changeFontSize}"
        v-on:mouseleave="{color:buttonParam.endColor, background:buttonParam.endBackground, fontSize: buttonParam.endFontSize}">
        按钮变换
      </button>-->
      <test></test>
      <SimpleClickEvent v-bind:param-title="simpleClickEventParam.paramTitle" v-bind:param-count= "simpleClickEventParam.paramCount"></SimpleClickEvent>
    </div>
  </div>
</template>

<script type="text/javascript">
  import SimpleClickEvent from './common/SimpleClickEvent.vue'
  import test from './common/Test.vue'

  export default {
    name: "Info",
    data() {
      return {
        ravHtml: '<span style="color:blue">show color is blue by Insert html</span>',
        color: "myColor",
        see: true,
        message: "vue.test",
        param: [
          {name: "动态颜色", value: "red"},
          {name: "动态颜色1", value: "blue"},
          {name: "动态颜色:白色", value: "#fff"},
          {name: "动态颜色：黑色", value: "#000"},
        ],
        number: 3,
        isOk: true,
        url: "https://cn.vuejs.org/v2/guide/conditional.html",
        list: [1, 2, 3],
        buttonControl: ["simpleButton", "buttonOn", "buttonOff", "leaveButton"],
        actionStyle: {
          fontAction: {name: "文字特效", value: "fontAction", type: "default", classStyleConfig: {}}
        },
        classStyle: {
          color: "",
          background: "",
          fontSize: "40px"
        },
        buttonParam: {
          startColor: '',
          startBackground: '',
          startFontSize: '',
          changeColor: '#ff0c16',
          changeBackground: '#ffe082',
          changeFontSize: 'larger',
          endColor: '#ff0c16',
          endBackground: '#ffe082',
          endFontSize: 'large'
        },
        simpleClickEventParam:{
          paramTitle: "小婷",
          paramCount:0
        }
      }
    },
    methods: {
      click_a: function (x) {
        if (x) {
          this.isOk = !x;
          this.color = "red";
          console.log("click a:" + this.isOk);
        } else {
          this.isOk = !x;
          this.color = "myColor";
          console.log("click a:" + this.isOk);
        }
      },
      click_b: function () {
        this.message = "change.vue";
        console.log("click b");
      },
      click_c: function (x) {
        this.isOk = x;
        this.message = "click.stop";
        console.log("click c:" + this.isOk);
      },
      click_event: function (number, message, e) {
        this.number = number + 10;
        this.message = "事件点击处理：" + message;
        console.log(e);
      }
    },
    components: {
      SimpleClickEvent,
      test
    }
  }
</script>

<style scoped>
  div, table, tr, th, p, span {
    margin: 0;
    padding: 0;
    border: 0;
  }
  .first-level {
    margin: auto;
    width: 800px;
    border: 2px;
    border-style: dotted solid double dashed;
    border-bottom-color: blue;
  }
  .first-level .second-level-div-a {
    margin: 10px auto;
    padding-bottom: auto;
    width: 400px;
    border-width: 5px;
    border-color: rgba(34, 34, 80, 0.4);
    border-style: groove ridge inset outset;
    font-size: large;
  }
  .first-level .second-level-div-b {
    margin: 10px auto;
    width: 200px;
    border-width: 5px;
    border-color: red;
    border-style: hidden dot-dot-dash dot-dash outset;
  }
  .first-level .second-level-div-c {
    display: inline-block;
    margin: 10px;
    border-width: 5px;
    border-color: red;
    border-style: ridge;
  }
  .first-level .second-level-div-d {
    display: inline-block;
    margin: 10px;
    border-width: 5px;
    border-color: #ff7618;
    border-style: ridge;
  }
  .first-level .second-level-div-e {
    display: inline-block;
    margin: 10px;
    border-width: 5px;
    border-color: #42eaff;
    border-style: groove;
  }
  .first-level .second-level-div-c .third-level-div-a {
    position: inherit;
    display: inline-block;
    float: left;
    margin: 10px;
    border-width: 5px;
    border-color: #ffdf62;
    border-style: ridge;
  }
  .first-level .second-level-div-c .third-level-div-b {
    position: inherit;
    float: left;
    display: inline-block;
    margin: 10px;
    border-width: 5px;
    border-color: #1e75ff;
    border-style: groove;
  }
  .first-level .second-level-div-c .third-level-div-c {
    position: inherit;
    float: left;
    top: 20px;
    display: inline-block;
    margin: 10px;
    border-width: 5px;
    border-color: #1e75ff;
    border-style: groove;
  }
  .first-level .second-level-div-e button {
    position: unset;
    margin: 10px;
    border-width: 0px;
    border-color: #42eaff;
    border-style: groove;
    color: rgb(255, 7, 109);
    border-radius: 10px;
  }
  .first-level .table-a {
    margin: 2px;
    padding: 2px;
    border-color: #2e22ff;
    border-width: 5px;
    background: #77fff7;
    border-style: inherit;
  }
  table {
    margin: 2px;
    width: auto;
    height: auto;
    size: 30px;
  }
  tr {
    margin: 5px;
    padding: 2px;
    text-align: center;
    border-style: inset ridge groove dashed;
  }
  th {
    margin: auto;
    padding: 5px;
    text-align: center;
    font-size: large;
    border-width: 5px;
    border-style: double solid dotted none;
  }
  td {
    margin: auto;
    border-width: 5px;
    border-color: tomato;
    border-style: double;
  }
  ul {
    margin: auto;
    display: inline-block;
    border-width: 5px;
    border-style: groove;
  }
  li {
    margin: 10px;
    float: left;
    display: inline-block;
    border-width: 2px;
    border-color: aqua;
    border-style: ridge;
  }
  li p {
    border: inherit;
    border-style: ridge none none none;
  }
  p {
    border: blue;
  }
  .a {
    border-style: wave wave wave wave;
  }
  .b {
    border-style: inherit;
  }
  .c {
    border-style: initial;
  }
  .d {
    border-style: revert;
  }
  .e {
    border-style: unset;
  }
  .red {
    color: red;
    size: 20px;
  }
  .green {
    color: #42b983;
  }
  .myColor {
    color: #605EFF;
    size: 20px;
  }
  .font_change {
    font-size: xx-large;
  }
  .fontAction {
    font-size: larger;
    color: #60e8ff;
  }
  .simpleButton {
  }
  .buttonOn {
  }
  .buttonOff {
  }
  .leaveButton {
  }
</style>



// WEBPACK FOOTER //
// src/components/Info.vue